import { useRef, useEffect, useState } from 'react';
import gsap from 'gsap';
import logo from '../images/logo.png';
import './Loader.css';

export default function Loader({ onComplete }) {
  const overlayRef = useRef(null);
  const logoRef = useRef(null);
  const progressRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const counter = { value: 0 };

    const logoTween = gsap.to(logoRef.current, {
      scale: 1.08,
      duration: 0.9,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut',
    });

    const tl = gsap.timeline({
      onComplete: () => {
        gsap.to(overlayRef.current, {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.inOut',
          onComplete,
        });
      },
    });

    tl.to(counter, {
      value: 100,
      duration: 1.8,
      ease: 'power2.inOut',
      onUpdate: () => setProgress(Math.round(counter.value)),
    });

    tl.from(progressRef.current, { scaleX: 0, duration: 1.8, ease: 'power2.inOut' }, 0);

    return () => {
      tl.kill();
      logoTween.kill();
    };
  }, [onComplete]);

  return (
    <div ref={overlayRef} className="loader">
      <img ref={logoRef} src={logo} alt="OBC Card" className="loader__logo" />
      <div className="loader__bar-track">
        <div ref={progressRef} className="loader__bar-fill" style={{ transformOrigin: 'left' }} />
      </div>
      <span className="loader__percent">{progress}%</span>
    </div>
  );
}
